/* ============================================================
   W&O Accessibility runtime polish (WCAG 2.1 AA)
   Loaded with `defer` from theme.liquid.
   ============================================================ */
(function () {
  'use strict';

  // -------------------------------------------------------------
  // Slick ARIA scrubber (WCAG 1.3.1, 4.1.2)
  // Slick generates invalid ARIA on .slick-track and unlabelled slides.
  // -------------------------------------------------------------
  function scrubSlick(root) {
    var scope = root || document;
    scope.querySelectorAll('.slick-track').forEach(function (t) {
      t.removeAttribute('role');
      t.removeAttribute('aria-required');
    });
    scope.querySelectorAll('.slick-slide').forEach(function (s, i) {
      s.setAttribute('aria-roledescription', 'slide');
      if (!s.hasAttribute('aria-label')) {
        s.setAttribute('aria-label', 'Slide ' + (i + 1));
      }
      s.removeAttribute('aria-selected');
    });
    scope.querySelectorAll('.slick-dots').forEach(function (d) {
      d.setAttribute('role', 'tablist');
      d.querySelectorAll('li').forEach(function (li) { li.removeAttribute('role'); });
      d.querySelectorAll('li button').forEach(function (b) { b.setAttribute('role', 'tab'); });
    });
  }

  // -------------------------------------------------------------
  // Scrollable region setter (WCAG 2.1.1, 1.3.1)
  // Horizontal scrollers need keyboard reach + a label.
  // -------------------------------------------------------------
  var scrollRegions = [
    { selector: '.wo-trust-bar__grid', label: 'Trust indicators' },
    { selector: '.mobile-catergory', label: 'Shop by category' },
    { selector: '.marquee-track', label: 'Category carousel' },
    { selector: '[id^="product-gallery-carousel"]', label: 'Product gallery' }
  ];
  function markScrollRegions() {
    scrollRegions.forEach(function (r) {
      document.querySelectorAll(r.selector).forEach(function (el) {
        if (el.hasAttribute('data-wo-region-applied')) return;
        if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
        if (!el.hasAttribute('role')) el.setAttribute('role', 'region');
        if (!el.hasAttribute('aria-label')) el.setAttribute('aria-label', r.label);
        el.setAttribute('data-wo-region-applied', '');
      });
    });
  }

  // -------------------------------------------------------------
  // Decorative SVG hider (WCAG 1.1.1)
  // Any <svg> with no <title>, aria-label, or aria-labelledby is decorative.
  // -------------------------------------------------------------
  function hideDecorativeSvgs(root) {
    var scope = root || document;
    scope.querySelectorAll('svg').forEach(function (svg) {
      if (svg.hasAttribute('aria-hidden')) return;
      if (svg.hasAttribute('aria-label') || svg.hasAttribute('aria-labelledby')) return;
      if (svg.querySelector('title')) return;
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
    });
  }

  // -------------------------------------------------------------
  // Slideshow pause button binding (WCAG 2.2.2)
  // Button markup is rendered server-side in slideshow.liquid.
  // -------------------------------------------------------------
  function bindSlideshowPause() {
    document.querySelectorAll('[data-wo-slideshow-pause]').forEach(function (btn) {
      if (btn.__woBound) return;
      btn.__woBound = true;
      btn.addEventListener('click', function () {
        var carousel = btn.closest('slideshow-carousel') ||
                       btn.closest('section').querySelector('slideshow-carousel');
        if (!carousel) return;
        var paused = carousel.hasAttribute('paused') || !carousel.hasAttribute('autoplay');
        if (paused) {
          carousel.setAttribute('autoplay', '');
          carousel.removeAttribute('paused');
          btn.setAttribute('aria-pressed', 'false');
          btn.setAttribute('aria-label', 'Pause slideshow');
        } else {
          carousel.removeAttribute('autoplay');
          carousel.setAttribute('paused', '');
          btn.setAttribute('aria-pressed', 'true');
          btn.setAttribute('aria-label', 'Play slideshow');
        }
        var pauseIcon = btn.querySelector('.wo-slideshow-pause__pause');
        var playIcon = btn.querySelector('.wo-slideshow-pause__play');
        if (pauseIcon && playIcon) {
          pauseIcon.style.display = paused ? '' : 'none';
          playIcon.style.display = paused ? 'none' : '';
        }
      });
    });
  }

  // -------------------------------------------------------------
  // Live-region cart announcer (WCAG 4.1.3)
  // theme.liquid renders <div id="wo-a11y-live" role="status" aria-live="polite">
  // -------------------------------------------------------------
  function announce(msg) {
    var live = document.getElementById('wo-a11y-live');
    if (!live) return;
    live.textContent = '';
    setTimeout(function () { live.textContent = msg; }, 50);
  }
  function bindCartAnnouncer() {
    document.addEventListener('cart:change', function (e) {
      var count = (e.detail && e.detail.cart && e.detail.cart.item_count) ||
                  (document.querySelector('cart-count') && document.querySelector('cart-count').textContent) ||
                  '';
      announce('Cart updated. ' + count + ' items in cart.');
    });
    document.addEventListener('cart:item-added', function () {
      announce('Item added to cart.');
    });
  }

  // -------------------------------------------------------------
  // Init
  // -------------------------------------------------------------
  function runAll(root) {
    scrubSlick(root);
    markScrollRegions();
    hideDecorativeSvgs(root);
    bindSlideshowPause();
  }
  function init() {
    runAll(document);
    bindCartAnnouncer();
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes && m.addedNodes.forEach(function (n) {
          if (n.nodeType === 1) runAll(n);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
